import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import HeroBackground from '../components/HeroBackground';
import { NAV_TAGLINE } from '../components/NavTaglineStrip';
import VerticalTickerRail from './TickerSection';
import { fadeUp, staggerContainer } from '../motion/variants';

const KPIS = [
  { v: '25+', l: 'Countries Served', accent: 'gold' },
  { v: '2,400+', l: 'Formulations', accent: 'blue' },
  { v: 'FDA', l: '21 CFR Ready', accent: 'green' },
  { v: 'ISO', l: '9001 & 14001', accent: 'navy' },
];

export default function HeroSection() {
  return (
    <section id="hero" className="sec-process-wrap hero--colorlab hero--has-video hero--has-slider hero--split" data-palette="white">
      <div className="hero-split">
        <div className="hero-split__media">
          <HeroBackground />
          <VerticalTickerRail className="ticker-rail--hero" />
          <motion.div
            className="scroll-cue"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.6 }}
          >
            <div className="sc-line" />
            <span className="sc-text">Scroll</span>
          </motion.div>
        </div>

        <motion.div
          className="hero-split__kpis h-kpis"
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
        >
          {KPIS.map((kpi) => (
            <motion.div key={kpi.l} className="hero-kpi-card" data-accent={kpi.accent} variants={fadeUp}>
              <div className="kpi-v">{kpi.v}</div>
              <div className="kpi-l">{kpi.l}</div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="hero-split__panel sec-process-content"
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="hero-left hero-copy-readable" variants={fadeUp}>
            <div className="eyebrow">Advanced Masterbatch &amp; Additive Solutions</div>
            <h1 className="hero-headline--split">
              Engineering <em>color.</em>
              <br />
              Advancing sustainability.
            </h1>
            <div className="h-rule" />
            <p className="h-desc hero-split__tagline">
              <strong>{NAV_TAGLINE}</strong>
            </p>
            <div className="h-btns">
              <Link to="/products" className="btn-p">
                Explore Solutions
              </Link>
              <Link to="/contact" className="btn-g">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
                  <path
                    d="M1 7h12M8 2l5 5-5 5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Request a Sample
              </Link>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
